export default {
  SHARE_SCOPE_GROUP1: 0b111,
  SHARE_SCOPE_GROUP2: 0b011,
  SHARE_SCOPE_GROUP3: 0b001,
};
